module.exports = __webpack_public_path__ + "static/humanoid-3f328ffb05ab7defdd44e25c6ce8c383.gif";